<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem }"
    custom-export-url="/show-bands/export/"
    has-availabilities
  >
    <template v-slot:form="{ editedItem, error }">
      <v-row>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.band"
            :error-messages="error.band"
            :model="bandModel"
            item-text="name"
            item-value="id"
            label="Gruppo"
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="editedItem.status"
            :error-messages="error.status"
            :items="[
              { value: 1, text: 'selezionato' },
              { value: 2, text: 'contattato' },
              { value: 3, text: 'approvato' },
            ]"
            label="Stato"
          ></v-select>
        </v-col>
      </v-row>
      <p v-if-superuser>
        <span v-if="get(editedItem, 'band__members')">
          <b>Membri:</b>
          {{ editedItem.band__members }}
          <br />
        </span>
        <span v-if="get(editedItem, 'band__referent__name')">
          <b>Referente:</b>
          {{ editedItem.band__referent__name }}

          <template v-if="get(editedItem, 'band__referent__telephone_number')">
            - {{ editedItem.band__referent__telephone_number }}
          </template>
          <template v-if="get(editedItem, 'band__referent__email')">
            - {{ editedItem.band__referent__email }}
          </template>
        </span>
      </p>
    </template>

    <template v-slot:item.status="{ item }">
      <status-indicator small :status="item.status" />
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"
import statuses from "@/statuses"

export default {
  data() {
    return {
      modelHeaders: [
        { text: "Gruppo", value: "band__name" },
        { text: "Stato", value: "status" },
      ],
      model: models.ShowBand,
      bandModel: models.Band,
      statuses,
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      availabilities: [],
      band: null,
    }),
  },
}
</script>
